import { render } from "./Footer.vue?vue&type=template&id=0d50550a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=0d50550a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d50550a"

export default script